export const projects = [
  {
    title: "Sharing is Scary",
    subtitle: "Full Stack Art Sharing App",
    description:
      "This app utilizes EJS and Multer to allow people to share their artwork with others.",
    image: "Screen Shot 2022-02-06 at 4.24.15 PM.png",
    link: "https://bestartshare.herokuapp.com/",
  },
  {
    title: "Accompli",
    subtitle: "MERN Stack Productivity App",
    description: "Built with MongoDB, Express, React, and Node to provide a place where one can keep track of their goals.",
    image: "Screen Shot 2022-02-05 at 12.51.04 PM.png",
    link: "https://accompli-frontend-app.herokuapp.com/",
  },
  {
    title: "Travel Advisor",
    subtitle: "React app with APIs",
    description: "A travel advisor app built using React, Google Maps API and Travel Advisor API.",
    image: "Screen Shot 2022-05-16 at 12.46.31 PM.png",
    link: "https://stupendous-pie-dc5cf7.netlify.app/",
  },
  {
    title: "",
    subtitle: "",
    description: "",
    image: "",
    link: "",
  },
];

// export const testimonials = [
//   {
//     quote: "",
//     image: "https://randomuser.me/api/portraits/men/1.jpg",
//     name: "Jesse Hicks",
//     company: "Zoozle",
//   },
//   {
//     quote: "",
//     image: "https://randomuser.me/api/portraits/men/94.jpg",
//     name: "Ruben Alvarez",
//     company: "Dooble.io",
//   },
// ];

export const skills = [

  "CSS frameworks",
  "JavaScript",
  "React",
  "Python",
  "Node",
  "Express",
  "MongoDB"

];

export const certifications = [
  {
    image: "https://i.imgur.com/0lREMdO.jpg"
  }
]

export const badge = [
  {
    image: "https://imgur.com/a/ecag8J7"
  }
]


// WEBPACK FOOTER //
// ./src/data.js